import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Home, Sparkles, Gift } from 'lucide-react';
const benefits = [{
  icon: Heart,
  title: 'Aprendé desde cero',
  desc: 'Aunque nunca hayas hecho manualidades, vas paso a paso con guía y videos.'
}, {
  icon: Sparkles,
  title: 'Creá flores que no se marchitan',
  desc: 'Ramos, detalles y regalos personalizados que duran mucho más que las flores naturales.'
}, {
  icon: Home,
  title: 'Empezá con materiales económicos',
  desc: 'Usá limpiapipas y materiales simples, fáciles de conseguir y sin gran inversión inicial.'
}, {
  icon: Gift,
  title: 'Vendé en fechas especiales',
  desc: 'Cumpleaños, Día de la Madre, San Valentín, aniversarios, eventos y regalos personalizados.'
}];
export function Benefits() {
  return <section className="py-8 sm:py-10 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-27">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 max-w-6xl mx-auto" data-id="element-28">
        {benefits.map((benefit, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-deco-card rounded-[2rem] p-6 sm:p-8 shadow-sm border border-deco-warm hover:shadow-md transition-shadow flex flex-col items-center text-center relative overflow-hidden" data-id="element-29">
            <div className="absolute top-0 right-0 w-32 h-32 bg-deco-bg rounded-bl-full -z-10 opacity-50" data-id="element-30"></div>

            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-deco-warm flex items-center justify-center mb-5 text-deco-terra border border-deco-warm" data-id="element-31">
              <benefit.icon size={24} strokeWidth={1.5} data-id="element-32" />
            </div>
            <h3 className="text-lg sm:text-xl mb-3 text-deco-text font-serif font-bold leading-tight" data-id="element-33">
              {benefit.title}
            </h3>
            <p className="text-deco-text/70 leading-relaxed font-normal text-sm" data-id="element-34">
              {benefit.desc}
            </p>
          </motion.div>)}
      </div>
    </section>;
}